module.exports = __webpack_public_path__ + "media/images/payments/webmoney-ce04235265136eb8d8c3e08c84245fdc.svg";